export const PROPERTY_TYPE_KEYWORDS = {
    SINGLE_FAMILY: 'SINGLE FAMILY',
    RURAL_RESIDENCE: 'RURAL RESIDENCE',
    MULTI_FAMILY: 'MULTI-FAMILY',
    APARTMENT: 'APARTMENT',
    TRIPLEX: 'TRIPLEX',
    QUADPLEX: 'QUADPLEX',
    DUPLEX: 'DUPLEX',
    CONDOMINIUM: 'CONDOMINIUM',
    TOWNHOUSE: 'TOWNHOUSE',
    TIMESHARE: 'TIMESHARE',
    CONDOTEL: 'CONDOTEL',
    NON_WARRANTABLE_CONDO: 'NON-WARRANTABLE CONDO',
    MODULAR: 'MODULAR',
    PUD: 'PUD',
    COOP: 'COOP',
    CO_OPERATIVE: 'CO-OPERATIVE',
    MANUFACTURED: 'MANUFACTURED',
    MOBILE_HOME: 'MOBILE HOME',
    VACANT_LAND: 'VACANT LAND',
    OTHER: 'OTHER',
    AGRICULTURAL: 'AGRICULTURAL',
    COMMERCIAL: 'COMMERCIAL',
    INDUSTRIAL: 'INDUSTRIAL',
    RESIDENTIAL_MIS: 'RESIDENTIAL MIS',
    PARKING: 'PARKING',
    STORAGE: 'STORAGE',
    COMMON_AREA: 'COMMON AREA',
};
export const PROPERTY_TYPE_RESULTS = {
    SINGLE_FAMILY: 'SingleFamily',
    CONDO: 'Condo',
    TOWNHOUSE: 'Townhouse',
    TIMESHARE: 'Timeshare',
    CONDOTEL: 'Condotel',
    NON_WARRANTABLE_CONDO: 'NonWarrantableCondo',
    MODULAR: 'Modular',
    PUD: 'Pud',
    COOP: 'Coop',
    MANUFACTURED: 'ManufacturedDoubleWide',
};
export const UNITS = {
    ONE: 'OneUnit',
    TWO: 'TwoUnits',
    THREE: 'ThreeUnits',
    FOUR: 'FourUnits',
};
export const ERROR_PROPERTY_TYPES = [
    PROPERTY_TYPE_KEYWORDS.VACANT_LAND,
    PROPERTY_TYPE_KEYWORDS.OTHER,
    PROPERTY_TYPE_KEYWORDS.AGRICULTURAL,
    PROPERTY_TYPE_KEYWORDS.COMMERCIAL,
    PROPERTY_TYPE_KEYWORDS.INDUSTRIAL,
    PROPERTY_TYPE_KEYWORDS.RESIDENTIAL_MIS,
    PROPERTY_TYPE_KEYWORDS.PARKING,
    PROPERTY_TYPE_KEYWORDS.STORAGE,
    PROPERTY_TYPE_KEYWORDS.COMMON_AREA,
];
export const ERROR_PROPERTY_TYPE = 'ErrorPropertyType';
